"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoHeaderData = void 0;
const react_1 = __importDefault(require("react"));
const lang = __importStar(require("./lang.json"));
require("./info-header-data.css");
const InfoHeaderData = ({ insuredAssets, handleModifyClick, children, dataColor = "#6e6e6e" }) => {
    return (react_1.default.createElement("div", { className: "info-header-data-button-container", "data-testid": "info-header-data-element" },
        react_1.default.createElement("div", { className: "info-header-data-container" }, insuredAssets &&
            insuredAssets.map(({ title, value }, index) => {
                return (react_1.default.createElement("div", { className: "info-header-data-item", key: index, style: { color: dataColor } },
                    react_1.default.createElement("span", { className: "info-header-data-item-title" }, title),
                    react_1.default.createElement("span", { className: "info-header-data-item-value" }, value)));
            })),
        children && (react_1.default.createElement("div", { className: "info-header-data-button-container" },
            react_1.default.createElement("button", { className: "info-header-data-button", onClick: handleModifyClick }, lang.buttonText)))));
};
exports.InfoHeaderData = InfoHeaderData;
//# sourceMappingURL=info-header-data.js.map